<template lang="pug">
.ixaContainer
  .ixaMainContainer(sticky-container class="sticky-container")
    .sticky(v-sticky sticky-offset="{top: 52}" sticky-side="both" sticky-z-index="20")
      h2: img(src="../assets/numbers4.svg" width="50")
      table.table.is-bordered.is-narrow.is-fullwidth
        thead
          tr
            th 生成/総数 
            th 生成額 
            th 選択額 
            th 割合
        tbody
          tr
            td {{N4.length}} / 10,000 
            td ¥ {{N4.length * 200}}
            td ¥ {{selectedPrice}}
            td {{N4probability}} %

      .ixaMetaContainer(:class="{'mobile': isMobileDevice, 'desktop': !isMobileDevice}")
        b-button.button.is-small(@click="reset($event)" type="is-primary") リセット 
        b-button.button.is-small(@click="saveNumber($event)" type="is-primary") 選択を保存
        b-button.button.is-small(@click="createNumbers4_100($event)" type="is-primary") 100個生成
        b-button.button.is-small(@click="createNumbers4($event)" type="is-primary") ナンバーズ4 生成

    .resultContainer
      table.table.is-bordered.is-narrow.is-fullwidth
        thead
          tr
            th.date 日付
            th.winningNumber 当選番号
        tbody
          tr(v-for="num in numbers4WinningNumber" :key="num.number")
            td.winningdate {{num.date}}
            td.winningnumber {{num.number}}
            
    .numberListContainer
      b-field
        b-checkbox-button(v-for="N4p in N4" v-model="N4M" size="is-small" :key="N4p" :native-value="N4p") {{N4p}}
</template>

<script>
const Random = require('random')
const D3Random = require('d3-random')
const UAParser = require('ua-parser-js')
export default {
  name: 'numbers4',
  data(){
    return {
      N4M: [],
      tN4: [],
      isMobileDevice: null
    }
  },
  computed: {
    selectedPrice(){
      return (this.N4M.length) * 200
    },
    N4probability(){
      return ((this.N4.length / 10000) * 100).toFixed(1)
    },
    N4: {
      get(){
        return this.tN4
      },
      set(val){
        this.tN4.push(val)
      },
    },
    numbers4WinningNumber(){
      return this.$store.getters['ixa/getNumbers4WinningNumber']
    }
  },
  methods: {
    reset(ev){
      if(ev) ev.preventDefault()
      this.N4M = []
      this.tN4 = []
    },
    saveNumber(ev){
      if(ev) ev.preventDefault()
      if(this.N4M.length > 0){
        this.$store.dispatch('ixa/setNumbers4', this.N4M)
        this.$buefy.toast.open({
          duration: 3000,
          message: `選択を保存しました。「履歴」ページで確認できます`,
          position: 'is-bottom',
          type: 'is-primary'
        })
      }else{
        this.$buefy.toast.open({
          duration: 3000,
          message: `選択数字がありません。操作をスキップします`,
          position: 'is-bottom',
          type: 'is-primary'
        })
      }
    },
    createNumbers4(ev){
      if(ev) ev.preventDefault()
      if(this.tN4.length === 10000){
        return;
      }else{
        let num = null
        while(true){
          num = ( '0000' + Math.floor(D3Random.randomUniform(0, 10000)())).slice(-4)
          if(!this.tN4.includes(num)){
            this.tN4.push(num)
            break
          }
        }
      }
    },
    createNumbers4_100(ev){
      if(ev) ev.preventDefault()
      let loop = 100
      if(this.tN4.length > 9900){
        loop = 10000 - this.tN4.length
      }
      for(let outsideLoopCtr = 0; outsideLoopCtr < loop; outsideLoopCtr++){
        let num = null
        while(true){
          num = ( '0000' + Math.floor(D3Random.randomUniform(0, 10000)())).slice(-4)
          if(!this.tN4.includes(num)){
            this.tN4.push(num)
            break
          }
        }

      }
    },
  },
  created(){
    this.isMobileDevice = UAParser().device.type === 'mobile'? true : false
  },
  mounted(){
    this.$EventBus.$emit('naviClose')
  }
}
</script>

<style scoped lang="stylus">
.ixaContainer
  margin-top: 52px!important
  padding-bottom: 60px
  width: 100%
  .ixaMainContainer
    width: 96%
    margin: 60px auto 60px auto
    .sticky
      background-color: #FFF!important
      padding-bottom: 10px
      h2
        text-align: center
      .table.is-bordered.is-narrow
        margin-bottom: 12px!important
        tr, td
          font-size: 0.8rem
      .ixaMetaContainer
        display: flex
        .button
          margin-right: 5px
        &.mobile
          justify-content: space-between
        &.desktop
          justify-content: center
    .numberListContainer
      margin-top: 20px
      .button.n
        width: 70px!important
        margin: 4px
        &.selected
          background-color: #BA221E
  .resultContainer
    .table
      .date
        width: 30%!important
      td, th
        vertical-align: middle
        font-size: 0.8rem
</style>
